"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trueDocs = void 0;
var trueDocs = {
  name: 'true',
  category: 'Constants',
  syntax: ['true'],
  description: 'Boolean value true',
  examples: ['true'],
  seealso: ['false']
};
exports.trueDocs = trueDocs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/cjs/expression/embeddedDocs/constants/true.js
// module id = +S9g
// module chunks = 23